<template>
    <div class="main-width">
        <div class="location_css">
            <img src="../../assets/img/location.png">
            <div>当前位置：</div>
            <div @click="goSy()">首页</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div @click="goSy()">产业动态</div>
            <div> <i class="el-icon-arrow-right"></i> </div>
            <div class="location_text">{{selectChannelData.channelName}}</div>
        </div>
        <div class="culture_main">
            <div class="culture_left">
                <div class="culture_left_title">产业动态</div>
                <div>
                    <div class="culture_left_item" v-for="(item,index) in channelList" :key="index" @click="selectChannel(item)">
                        <div style="display: flex;">
                            <div class="culture_left_item_text" :class="{'culture_active':item.channelId == selectChannelData.channelId}">
                                <i class="el-icon-caret-right" style="margin-right: 9px"></i>{{item.channelName}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="background-color: #F6F6F6;padding: 15px 20px 20px 20px;width: 882px;" v-loading="loading">
                <div class="news_item child" v-for="(item,index) in result.list" :key="index">
                    <div class="news_item_cricle"></div>
                    <div class="news_item_text" style="width: 660px;">{{item.title}}</div>
                    <div class="news_item_date">{{item.postDate}}</div>
                </div>
                <div class="pagination" style="text-align: center;margin-top: 40px;margin-bottom: 10px;">
                    <el-pagination v-if="result.list.length > 0" background layout="total, prev, pager, next" :current-page="params.pageNum" :page-size="params.pageSize" :total="result.total" @current-change="pageChange"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            channelList: [],
            selectChannelData: {},
            result: { list: [] },
            params: { channelId: "", pageNum: 1, pageSize: 20 }
        }
    },
    methods: {
        //返回首页
        goSy: function() {
            this.$router.push({
                path: "/home"
            });
        },
        //翻页
        pageChange: function(page) {
            this.loading = true;
            this.params["pageNum"] = page;
            this.getNews();
        },
        //选择栏目
        selectChannel: function(data) {
            this.selectChannelData = data;
            this.params.channelId = data.channelId;
            this.params.pageNum = 1;
            this.loading = true;
            this.getNews();
        },
        //获取所有栏目
        getAllChannel: function() {
            let vue = this;
            return new Promise((resolve, reject) => {
                this.$axios.get("rrb-web/manageChannel/list", { params: { pageNum: 1, pageSize: 10000 } }).then(function(resp) {
                    if (resp.errcode == 0 || resp.errcode == "0") {
                        for (var i = 0; i < resp.data.dataList.length; i++) {
                            vue.channelList.push({ channelId: resp.data.dataList[i].channelId, channelName: resp.data.dataList[i].channelName });
                        };
                    };
                    resolve();
                }, function() {
                    resolve();
                });
            });
        },
        //获取新闻列表
        getNews: function() {
            let vue = this;
            this.$axios.get("rrb-web/news/content/ext/list", { params: this.params }).then(function(resp) {
                if (resp.errcode == 0 || resp.errcode == "0") {
                    for (var i = 0; i < resp.data.dataList.length; i++) {
                        if (resp.data.dataList[i].txt) {
                            resp.data.dataList[i].txt = resp.data.dataList[i].txt.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").replace(/\s+/g, "");
                        };
                        if (resp.data.dataList[i].postDate) {
                            resp.data.dataList[i].postDate = resp.data.dataList[i].postDate.split(" ")[0];
                        };
                    };
                    vue.result.list = resp.data.dataList;
                    vue.result.total = resp.data.totalRow;
                } else {
                    vue.$message.warning(resp.errtext);
                };
                vue.loading = false;
            }, function() {
                vue.loading = false;
            });
        },
    },
    mounted() {
        this.loading = true;
        var vue = this;
        this.getAllChannel().then(function() {
            vue.loading = false;
            vue.selectChannel(vue.channelList[0]);
        });
    }
}
</script>